import {isArray} from 'lodash';

export const normalizeOptions = (options = []) => {
  // @ts-expect-error TS(2322): Type '{}' is not assignable to type 'never'.
  const groupOptions = options.filter((item = {}) => isArray(item.options));
  // @ts-expect-error TS(2322): Type '{}' is not assignable to type 'never'.
  const orphanOptions = options.filter((item = {}) => !isArray(item.options));

  return [
    ...groupOptions,
    {
      label: null,
      options: orphanOptions,
    },
  ];
};
